import axios from "axios";
const SP_HOST = process.env.VUE_APP_SP_HOST;
const {VUE_APP_SP_USER_API} = process.env

export default () => {

  const url = VUE_APP_SP_USER_API ? `${VUE_APP_SP_USER_API}_api/Web/CurrentUser?$select=email` :`https://${SP_HOST}/sites/portal-new/_api/Web/CurrentUser?$select=email`

  return axios({
    method: "GET",
    url,
    headers: {
      Accept: "application/json;odata=verbose;",
      "Content-Type": "application/json;odata=verbose;",
    },
  });
};
